<div class="gaze-page">

  <!-- ── NAV ── -->
  <nav class="gaze-nav" [class.gaze-nav--scrolled]="scrolled">
    <span class="gaze-nav__logo">Gaze</span>
    <a href="javascript:void(0)" class="gaze-nav__link" (click)="scrollToDownload()">Download</a>
  </nav>

  <!-- ── HERO (parallax) ── -->
  <section class="gaze-hero" #heroSection>
    <img
      src="../../assets/images/gaze-marketing/hero.webp"
      alt="Window view from Paris, France"
      class="gaze-hero__bg"
      [style.transform]="'translateY(' + heroImgY + ')'"
    />
    <div class="gaze-hero__gradient"></div>

    <div
      class="gaze-hero__content"
      [style.transform]="'translateY(' + heroTextY + ')'"
      [style.opacity]="heroOpacity"
    >
      <h1 class="gaze-hero__title">Gaze</h1>
      <p class="gaze-hero__byline">by WindowSwap</p>
      <div class="gaze-divider"></div>
      <h2 class="gaze-content-h2">
        Gaze takes you far far away<br />
        from the madness of the internet.<br />
        By letting you stare out of<br />
        real people's window views.
      </h2>
      <div class="gaze-hero__buttons">
        <button class="gaze-ghost-btn" (click)="openAppStore()">↓ App Store</button>
        <button class="gaze-ghost-btn gaze-ghost-btn--dim" (click)="openPlayStore()">↓ Google Play</button>
      </div>
    </div>

    <p class="gaze-location-credit">Yvan — Paris, France</p>

    <div class="gaze-scroll-thread">
      <div class="gaze-scroll-line"></div>
    </div>
  </section>

  <!-- ── PRESS ── -->
  <section class="gaze-press">
    <p class="gaze-section-eyebrow">As seen in</p>
    <div class="gaze-press__logos">
      <img
        *ngFor="let logo of pressLogos"
        [src]="logo.src"
        [alt]="logo.alt"
        class="gaze-press__logo"
        [style.height.px]="logo.h"
      />
    </div>
  </section>

  <!-- ── SCROLL CAROUSEL (280 vh tall, sticky inner) ── -->
  <section class="gaze-gallery-section" #gallerySection>
    <div class="gaze-gallery-sticky">

      <div class="gaze-gallery-headline">
        <h2 class="gaze-content-h2">Choose from thousands of real window views.</h2>
      </div>

      <!-- filmstrip -->
      <div class="gaze-filmstrip-clip">
        <div
          class="gaze-filmstrip"
          [style.transform]="'translateX(' + stripX + ')'"
        >
          <div class="gaze-panel-wrap" *ngFor="let panel of carousel">
            <div
              class="gaze-panel"
              [style.width]="panel.w"
              [style.height]="panel.h"
            >
              <img
                [src]="panel.img"
                [alt]="panel.location"
                class="gaze-panel__img"
              />
              <div class="gaze-panel__gradient"></div>
              <p class="gaze-panel__credit gaze-panel__credit--desktop">{{ panel.location }}</p>
            </div>
            <p class="gaze-panel__credit gaze-panel__credit--mobile">{{ panel.location }}</p>
          </div>
          <div class="gaze-filmstrip-spacer"></div>
        </div>
      </div>

      <!-- progress bar -->
      <div class="gaze-progress-track">
        <div class="gaze-progress-fill" [style.width]="progressW"></div>
      </div>

    </div>
  </section>

  <!-- ── SOUNDS ── -->
  <section class="gaze-sounds">
    <img src="../../assets/images/gaze-marketing/sounds-bg.webp" alt="Window view at dusk" class="gaze-sounds__bg" />
    <div class="gaze-sounds__gradient"></div>

    <div class="gaze-sounds__content">
      <!-- animated soundwave -->
      <div class="gaze-soundwave">
        <div
          class="gaze-soundwave__bar"
          *ngFor="let amp of soundAmps; let i = index"
          [style.height]="barHeight(amp)"
          [style.animation-duration]="barDuration(i)"
          [style.animation-delay]="barDelay(i)"
        ></div>
      </div>

      <h2 class="gaze-content-h2">
        And hear the calming sounds<br />
        of real people's lives from all around the world.
      </h2>

      <!-- sound icons -->
      <div class="gaze-sound-icons">
        <!-- Rain -->
        <div class="gaze-sound-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M8 11 Q14 4 20 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none"/>
            <ellipse cx="14" cy="11" rx="7" ry="4.5" stroke="currentColor" stroke-width="1.2" fill="none"/>
            <line x1="9"  y1="17" x2="7"  y2="22" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
            <line x1="14" y1="17" x2="12" y2="22" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
            <line x1="19" y1="17" x2="17" y2="22" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
          </svg>
          <span>Rain</span>
        </div>
        <!-- Ocean -->
        <div class="gaze-sound-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M4 14 Q7 10 10 14 Q13 18 16 14 Q19 10 22 14 Q25 18 28 14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none"/>
            <path d="M4 19 Q7 15 10 19 Q13 23 16 19 Q19 15 22 19 Q25 23 28 19" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none" opacity="0.45"/>
          </svg>
          <span>Ocean</span>
        </div>
        <!-- Traffic -->
        <div class="gaze-sound-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <rect x="6" y="13" width="16" height="8" rx="3" stroke="currentColor" stroke-width="1.2" fill="none"/>
            <path d="M8 13 L10 8 L18 8 L20 13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <circle cx="10" cy="22" r="2" stroke="currentColor" stroke-width="1.2" fill="none"/>
            <circle cx="18" cy="22" r="2" stroke="currentColor" stroke-width="1.2" fill="none"/>
            <line x1="4" y1="17" x2="6" y2="17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
            <line x1="22" y1="17" x2="24" y2="17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
          </svg>
          <span>Traffic</span>
        </div>
        <!-- Daily life -->
        <div class="gaze-sound-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <circle cx="10" cy="7" r="3" stroke="currentColor" stroke-width="1.2" fill="none"/>
            <path d="M4 22 Q4 14 10 14 Q16 14 16 22" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none"/>
            <circle cx="19" cy="8" r="2.5" stroke="currentColor" stroke-width="1.2" fill="none"/>
            <path d="M14 22 Q14 15 19 15 Q24 15 24 22" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none"/>
          </svg>
          <span>Daily life</span>
        </div>
        <!-- Household -->
        <div class="gaze-sound-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M11 6 Q10 4 11 2" stroke="currentColor" stroke-width="1" stroke-linecap="round" fill="none" opacity="0.5"/>
            <path d="M14 6 Q13 4 14 2" stroke="currentColor" stroke-width="1" stroke-linecap="round" fill="none" opacity="0.5"/>
            <path d="M7 20 Q7 12 14 12 Q21 12 21 20 Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <path d="M21 15 Q25 14 25 17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none"/>
            <path d="M7 14 Q3 14 3 17 Q3 20 7 20" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none"/>
            <line x1="10" y1="12" x2="18" y2="12" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
            <circle cx="14" cy="11" r="1" stroke="currentColor" stroke-width="1" fill="none"/>
          </svg>
          <span>Household</span>
        </div>
      </div>
    </div>

    <p class="gaze-location-credit">Toulouse, France</p>
  </section>

  <!-- ── TIMER / SKY (250 vh tall, sticky inner) ── -->
  <section class="gaze-timer-section" #timerSection>
    <div class="gaze-timer-sticky">

      <!-- sky background -->
      <div class="gaze-sky" [style.background]="skyBg">
        <!-- sun / moon orb -->
        <div
          class="gaze-sky__orb"
          [style.left]="orbLeft"
          [style.top]="orbTop"
          [style.opacity]="orbOpacity"
          [style.background-color]="orbColor"
          [style.box-shadow]="orbShadow"
        ></div>
        <!-- grain overlay -->
        <div
          class="gaze-sky__grain"
          [style.background-position]="grainX + 'px ' + grainY + 'px'"
        ></div>
      </div>

      <!-- content -->
      <div class="gaze-timer-content">
        <h2 class="gaze-content-h2 gaze-timer__headline">
          Set a time to reflect,<br />and just gaze...
        </h2>

        <!-- slider card -->
        <div class="gaze-timer-card">
          <!-- draggable track -->
          <div
            class="gaze-slider-track"
            #sliderTrack
            (mousedown)="onSliderMouseDown($event)"
            (touchstart)="onSliderTouchStart($event)"
          >
            <!-- floating number above handle -->
            <div
              class="gaze-slider__label"
              [style.left]="sliderPct + '%'"
            >
              <span class="gaze-slider__minutes">{{ displayMinutes }}</span>
              <span class="gaze-slider__min-text">min</span>
            </div>

            <!-- bg line -->
            <div class="gaze-slider__bg-line"></div>

            <!-- filled line -->
            <div class="gaze-slider__fill" [style.width]="sliderPct + '%'"></div>

            <!-- tick marks -->
            <div
              class="gaze-slider__tick"
              *ngFor="let t of timerTicks"
              [style.left]="tickLeft(t)"
            ></div>

            <!-- handle -->
            <div
              class="gaze-slider__handle"
              [class.gaze-slider__handle--dragging]="dragging"
              [style.left]="sliderPct + '%'"
            ></div>
          </div>

          <!-- tick labels -->
          <div class="gaze-slider__labels">
            <span
              class="gaze-slider__tick-label"
              *ngFor="let t of timerTicks"
              [style.left]="tickLeft(t)"
              (click)="setTickValue(t)"
            >{{ t }}</span>
          </div>
        </div>
      </div>

    </div>
  </section>

  <!-- ── CALM + TESTIMONIALS ── -->
  <section class="gaze-calm">
    <img src="../../assets/images/gaze-marketing/calm-bg.webp" alt="Sophie, San Diego, CA, USA" class="gaze-calm__bg" />
    <div class="gaze-calm__gradient"></div>

    <p class="gaze-content-h2 gaze-calm__headline">
      until there's nothing<br />but calm all around you.
    </p>

    <div class="gaze-testimonial-wrap">
      <!-- quote card with CSS fade transition -->
      <div class="gaze-testimonial-card" [class.gaze-testimonial-card--visible]="quoteVisible">
        <p class="gaze-testimonial__quote">"{{ testimonials[quoteIndex].quote }}"</p>
        <p class="gaze-testimonial__author">
          {{ testimonials[quoteIndex].author }} — {{ testimonials[quoteIndex].location }}
        </p>
      </div>

      <!-- dot navigation -->
      <div class="gaze-testimonial__dots">
        <button
          *ngFor="let t of testimonials; let i = index"
          class="gaze-testimonial__dot"
          [class.gaze-testimonial__dot--active]="i === quoteIndex"
          (click)="setQuote(i)"
        ></button>
      </div>
    </div>

    <p class="gaze-location-credit">Sophie — San Diego, CA, USA</p>
  </section>

  <!-- ── STATS ── -->
  <section class="gaze-stats">
    <div class="gaze-stats__grid">
      <div class="gaze-stats__item" *ngFor="let s of stats">
        <p class="gaze-stats__number">{{ s.n }}</p>
        <p class="gaze-stats__label">{{ s.label }}</p>
      </div>
    </div>
  </section>

  <!-- ── CTA ── -->
  <section class="gaze-cta" id="download">
    <img src="../../assets/images/gaze-marketing/cta-bg.webp" alt="" aria-hidden="true" class="gaze-cta__bg" />
    <div class="gaze-cta__gradient"></div>
    <div class="gaze-cta__inner">
      <h1 class="gaze-cta__title">Gaze</h1>
      <p class="gaze-cta__byline">by WindowSwap</p>
      <div class="gaze-cta__buttons">
        <button class="gaze-ghost-btn gaze-ghost-btn--large" (click)="openAppStore()">Download for iOS</button>
        <button class="gaze-ghost-btn gaze-ghost-btn--large gaze-ghost-btn--dim" (click)="openPlayStore()">Download for Android</button>
      </div>
    </div>
  </section>

  <!-- ── FOOTER ── -->
  <footer class="gaze-footer">
    <span class="gaze-footer__logo">Gaze</span>
    <p class="gaze-footer__copy">by WindowSwap · © 2025</p>
    <div class="gaze-footer__links">
      <a href="/gaze-privacy" class="gaze-footer__link">Privacy</a>
      <a href="/gaze-terms"   class="gaze-footer__link">Terms</a>
      <a href="/gaze-support" class="gaze-footer__link">Contact</a>
    </div>
  </footer>

</div>
